"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SwapContext_1 = require("src/contexts/SwapContext");
const RefreshSVG_1 = __importDefault(require("src/icons/RefreshSVG"));
const WalletComponents_1 = require("./WalletComponents");
const BrandingProvider_1 = require("src/contexts/BrandingProvider");
const useBalances_1 = require("src/hooks/useBalances");
const Header = () => {
    const { refresh, enableWalletPassthrough } = (0, SwapContext_1.useSwapContext)();
    const { refetch: refetchBalances } = (0, useBalances_1.useBalances)();
    const { logoUri, name } = (0, BrandingProvider_1.useBranding)();
    const onRefresh = (0, react_1.useCallback)(() => {
        refetchBalances();
        refresh();
    }, [refetchBalances, refresh]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "mt-2 h-7 pl-3 pr-2", children: (0, jsx_runtime_1.jsxs)("div", { className: "w-full flex items-center justify-between ", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center space-x-2", children: [(0, jsx_runtime_1.jsx)("img", { src: logoUri, alt: "Plugin Branding", className: "w-6 h-6" }), (0, jsx_runtime_1.jsx)("span", { className: "font-bold text-sm text-primary-text", children: name })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex space-x-1 items-center", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "p-2 h-7 w-7 flex items-center justify-center  rounded-full  bg-interactive text-primary-text fill-current", onClick: onRefresh, children: (0, jsx_runtime_1.jsx)(RefreshSVG_1.default, {}) }), !enableWalletPassthrough && (0, jsx_runtime_1.jsx)(WalletComponents_1.WalletButton, {})] })] }) }));
};
exports.default = Header;
